export class Controller {

    /** @ngInject */
    constructor(Alert, UserNotesService,$state) {
        this.Alert = Alert;
        this.UserNotesService = UserNotesService;
        this.$state =$state;
    }

    $onInit() {
        this.note = {
			id:null,
            title: '',
            text: ''
        };
    }

    save() {
        this.isSaving = true;
        this.UserNotesService.save(this.note).$promise
            .then(note => {
                this.$state.go("^", {}, { reload: "^" });
                this.Alert('success', 'company.sharing-center.note.add.added');
            })
            .finally(() => this.isSaving = false)
    }

    saveDisabled(form) {
        return this.isSaving || form.$invalid;
    }

    
}



// WEBPACK FOOTER //
// ./src/portal/states/user/notes/add/add-note.controller.js